import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CashMemoForm from '../../components/pageModule/Cashmemos/CashMemoForm';
import { createCashMemo, setSelected, clearCurrentCashMemo } from '../../store/modules/cashmemo/cashmemoActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const CashmemosCreate = () => {
    const initialData = useRef({ 
        initialType: 'create',
        invoice_date: new Date().toISOString().split('T')[0]
    });
    const [formKey, setFormKey] = useState(0); // Add key state
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Clear any existing data when component mounts
    useEffect(() => {
        dispatch(clearCurrentCashMemo());
    }, [dispatch]);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createCashMemo(formData));
            toast.success('Cash memo created successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            if (response && response.id) {

                navigate(`/cash_memos/view/${response.id}?preview=true`);

                // Reset initialData and force remount
                // initialData.current = { 
                //     initialType: 'create',
                //     invoice_date: new Date().toISOString().split('T')[0]
                // };
                // setFormKey(prev => prev + 1);

                // Optionally, you can navigate or just reset the form
                // navigate(`/job_orders/create`);
                // navigate(`/cash_memos/edit/${response.id}`);
            }
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating cash memo', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
    };
    
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <CashMemoForm 
                                    key={formKey} // Force remount on key change
                                    initialData={initialData.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.create(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CashmemosCreate; 